module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"placeholder":"コメントをご記入ください","submit":"登録","cancel":"取り消す","create_comment_failure":"コメントの投稿中に問題が発生しました。","edit_comment_failure":"コメントの編集中に問題が発生しました。","confirm_cancel_edit":"コメント修正をキャンセルしますか？"}}')
  delete Component.options._Ctor
}
